import React from "react";

import { getCountForModel } from "../../../api";
import { logger } from "@synthesis/shared-utils";

const UUID_PATTERN = /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i;

export const useMarkUp = (id: string | undefined) => {
  const [markupsCount, setMarkupsCount] = React.useState<number | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const getMarkUp = React.useCallback(async (fileId: string) => {
    try {
      setIsLoading(true);
      const responseData = (await getCountForModel({ path: { modelId: fileId } })).data;
      setMarkupsCount(responseData.markupCount ?? 0);
    } catch (error) {
      setMarkupsCount(0);
      logger.error("error", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (!id || !UUID_PATTERN.test(id)) {
      setMarkupsCount(0);
      setIsLoading(false);
      return;
    }

    getMarkUp(id);
  }, [getMarkUp, id]);

  return { isLoading, markupsCount, getMarkUp };
};
